import slugify from 'slugify';
import React from 'react';
import { classnames } from 'Utils/classnames';

const nameMaper = _data => {
  if (!_data) {
    return null;
  }
  return {
    key: _data.k,
    name: _data.n,
    code: _data.c,
  };
};

export const upcomingRacesNameMapper = _data => {
  if (!_data) {
    return null;
  }
  return {
    cardId: _data.ci,
    hippodromeKey: _data.k,
    time: _data.t,
    hippodrome: _data.h,
    raceNo: _data.rn,
    distance: _data.d,
    runwayType: _data.rt,
    prize: _data.p,
    currency: _data.c,
    orderNo: _data.on,
    selectable: _data.s,
    sixPickDescription: _data.spd,
  };
};

export const hippodromesMapper = _data => {
  if (!_data) {
    return null;
  }
  return (
    _data.h?.map(e => {
      return {
        isSelected: e.is,
        cardId: e.cid,
        key: e.k,
        raceDate: e.rd,
        city: e.c,
        name: e.n,
        isNight: e.in,
        away: e.a,
        akey: e.akey,
        startTime: e.st,
        weatherInfo: e.wi ? {
          humidity: e.wi.h,
          weather: e.wi.w,
          condition: e.wi.c,
          pressure: e.wi.p,
          wind: e.wi.ws,
        } : null,
        runwayInfo: Array.isArray(e.ri) ? e.ri?.map(h => {
          return {
            RunwayTypeEnum: h.rte,
            condition: h.c,
            weight: h.w,
          };
        }) || [] : null,
      };
    })
  );
};

export const allHippodromesMapper = _data => {
  if (!_data) {
    return null;
  }
  return (
    _data?.h?.map(e => {

      return {
        key: e.k,
        hipodromeLocation: e.l,
        hipodromeName: e.n,
        name: e.hdn || e.n,
        abroad: e.a,
        location: e.k.toLowerCase(),
        cardId: e.cid
      };
    })
  );
};

export const availableBetsMapper = _data => {
  if (!_data) {
    return null;
  }
  return (
    _data.b?.map(e => {
      return {
        id: e.i,
        isSelected: e.is,
        description: e.d,
        descriptionAbbr: e.da,
        legSize: e.ls,
        boxTitle: e.bt,
        boxType: e.bte,
        betslipBoxTitle: e.bst,
        clientOrder: e.co,
        isCombinationActive: e.ica,
        minHorseSelectCount: e.mshc,
        infoMessages: e?.im || null,
        isOrdered: e?.io,
        isParlayable: e?.ip,
        selectableRaces: e.sa?.map(race => {
          return {
            isSelected: race.is,
            value: race.v,
            sixPickOrder: race.spo
          };
        }),
      };
    })
  );
};

const probablesCellMapper = _cell => {
  if (!_cell) {
    return null;
  }

  return {
    horseNo: _cell.hno,
    horseName: _cell.hn,
    horses: _cell.h,
    agf: _cell.a,
    betType: _cell.bt,
    winner: _cell.w,
    jockey: _cell.j,
    running: _cell.ir,
    ekuri: _cell.s
  };
};

export const probablesMapper = _data => {
  if (!_data) {
    return null;
  }
  if (!_data.ll) {
    return null;
  }

  return {
    currentRaceNumber: _data.crn,
    legList: _data.ll?.map(leg => {
      return {
        raceNo: leg.rn,
        prize: leg.p,
        currency: leg.c,
        name: leg.n,
        groupInfo: leg.gi,
        groupInfoAbbr: leg.gia,
        startTime: leg.st,
        gender: leg.g,
        raceType: leg.rt,
        distance: leg.d,
        runwayType: leg.rty,
        raceDetailText: leg.rd,
        winners: leg.w?.map(_w => probablesCellMapper(_w)),
        pairs: leg.pa?.map(_w => probablesCellMapper(_w)),
        orderedPairs: leg.op?.map(_w => probablesCellMapper(_w)),
        doubles: leg.do?.map(_w => probablesCellMapper(_w)),
        lspon: leg?.lspon
      };
    })
  };

};

export const horseMapper = horse => {
  return {
    key: horse.k,
    isRunning: horse.ir,
    stablemateGroupInfo: horse.sgi,
    comment: horse.c,
    agf: horse.a,
    agfOrderNo: horse.aon,
    secondAgf: horse.sa,
    secondAgfOrderNo: horse.saon,
    accessory: horse.ac,
    horseNo: horse.hn,
    name: horse.n,
    uniform: horse.u,
    probableGain: horse.g,
    s20: horse?.s20 || null,
    uniqId: horse.hn + '-' + slugify(horse.n, { lower: true }),
    tag: horse.t ? {
      isApprentice: horse.t.ia,
      isJockeyChanged: horse.t.ijc,
      weight: horse.t.w,
      weightChanges: horse.t.wd,
      handicap: horse.t.h,
      age: horse.t.a,
      lastRaceRanks: horse.t.lrr,
      boxNo: horse.t.b,
      isPreferredBoxNo: horse.t.ipbn,
      kgs: horse.t.k,
      isProbableGainIncreased: horse.t.ipgi,
      jokeyDetail: nameMaper(horse.t.jd),
    } : null,
    bestScoreText: horse.tda,
    eid: horse?.eid || null,
    exercise: horse.e ? {
      info: horse.e.i,
      jockey: horse.e.j,
      rankInformation: horse.e.ri,
    } : null,
    ownership: horse.ow ? {
      owner: nameMaper(horse.ow.o),
      coach: nameMaper(horse.ow.c),
      steward: nameMaper(horse.ow.s),
    } : null,
    origin: horse.o ? {
      father: nameMaper(horse.o.f),
      mother: nameMaper(horse.o.m),
      fathersFather: nameMaper(horse.o.ff),
      fathersMother: nameMaper(horse.o.fm),
      mothersFather: nameMaper(horse.o.mf),
      mothersMother: nameMaper(horse.o.mm),
    } : null,
    propositionInfo: fixedOddMapper(horse?.pi, horse?.spbah),
    lastThreeRaces: horse.lrl.map(ltr => {
      return {
        date: ltr.d,
        distance: ltr.di,
        hippodromeName: ltr.hn,
        rank: ltr.r,
        runwayType: ltr.rt
      };
    })
  };
};
export const betDetailsMapper = _data => {
  if (!_data) {
    return null;
  }

  return {
    cardId: _data.ci,
    raceDate: _data.rd,
    name: _data.n,
    akey: _data.akey,
    sixPickOrderNo: _data.spon,
    raceStatus: _data.raceStatus,
    legs: _data.l?.map(leg => {
      return {
        legNo: leg.ln,
        prize: leg.p,
        currency: leg.c,
        name: leg.n,
        groupInfo: leg.gi,
        groupInfoAbbr: leg.gia,
        startTime: leg.st,
        gender: leg.g,
        raceType: leg.rt,
        distance: leg.d,
        runwayType: leg.rty,
        eid: leg?.peid || null,
        weights: leg.w,
        raceDetailText: leg.rd,
        horseDetail: leg.h?.map(horseMapper),
        lspon: leg?.lspon,
        fodppim: leg?.fodppim
      };
    }),
  };
};

export const fixedOddMapper = (_data, spbah) => {
  return {
    propositionId: _data?.pid,
    odd: _data?.o,
    status: _data?.s,
    previousOdd: _data?.po || null,
    spbah
  };
};
export const agfSelectableListMapper = _data => {
  if (!_data) {
    return null;
  }
  return {
    agfSelectableList: _data.asl.map(asl => {
      return {
        name: asl.n,
        value: asl.v,
        sixPickOrder: asl.spo
      };
    })
  };
};

export const agfListMapper = _data => {
  if (!_data) {
    return null;
  }
  return {
    currentRaceNumber: _data.crn,
    agfList: _data.al?.map(al => {
      return {
        raceNo: al.rn,
        runwayType: al.rte,
        agfRaceInfoList: al.aril.map(aril => {
          return {
            agfRank: aril.ar,
            horseName: aril.hn,
            horseNo: aril.hno,
            agf: aril.a,
            jockeyName: aril.jn,
            stablemateAgf: aril.sa,
            stablemate: aril.s,
            raceNo: aril.rn,
            isRunning: aril.ir
          };
        })
      };
    })
  };
};

export const couponPrizeResultsMapper = _data => {
  if (!_data) {
    return null;
  }
  return {
    raceResults: _data?.map(res => {
      return {
        name: res.betTypeName,
        result: res.result,
        amount: res.price,
        currency: res.currency,
        clientOrder: res.clientOrder

      };
    })
  };
};

export const upcomingRacesMapper = _data => {
  if (!_data) {
    return null;
  }
  return _data.ur?.map(hipp => {
    return {
      name: hipp.n,
      raceDetailList: hipp.urdl.map(item => (upcomingRacesNameMapper(item))),
    };
  });
};

export const horseRacingResultsMapper = _data => {
  if (!_data) {
    return null;
  }

  return {
    hippodromes: _data.h?.map(hipp => ({
      name: hipp.n,
      key: hipp.k,
      date: hipp.d,
      betInfo: hipp.bi,
    })),
    latestRaceResults: _data.lr?.map(rr => ({
      race: rr.r ? { time: rr.r?.t, hippodrome: rr.r?.h, no: rr.r.n } : null,
      winnerHorseList: rr.whl?.map(w => ({
        no: w.n,
        name: w.nm,
        winner: w.w
      })),
      betResultList: rr.br?.map(b => ({
        name: b.n,
        detail: b.d,
        result: b.r,
        amount: b.a,
        currency: b.c,
        official: b.o,
        noWinner: b.nw,
        description: b.d
      }))
    })),
  };
};

export const horseRacingHippodromeResultsMapper = _data => {
  if (!_data) {
    return null;
  }

  return {
    resultList: _data.rl?.map(b => ({
      name: b.n,
      detail: b.d,
      result: b.r,
      amount: b.a,
      currency: b.c,
      official: b.o,
      noWinner: b.nw,
    })),
    winnerPayoutList: _data.wpl?.map(w => ({
      name: w.n,
      payout: w.p,
      currency: w.c,
      official: w.o,
      noWinner: w.nw,
    })),
    raceVideoList: _data.rvl?.map(r => ({
      no: r.n,
      videoUrl: r.vu,
      horses: r.hl?.map(h => ({
        horseNo: h.hn,
        horseName: h.hrn,
        jockeyName: h.jn,
        winner: h.w,
      }))

    })),
  };
};

export const horseRacingHippodromeRunResultsMapper = _data => {
  if (!_data) {
    return null;
  }

  return {
    raceDate: _data.rd,
    name: _data.n,
    legs: _data.l?.map(leg => {
      return {
        legNo: leg.ln,
        prize: leg.p,
        currency: leg.c,
        name: leg.n,
        groupInfo: leg.gi,
        groupInfoAbbr: leg.gia,
        startTime: leg.st,
        gender: leg.g,
        raceType: leg.rt,
        distance: leg.d,
        runwayType: leg.rty,
        weights: leg.w,
        videoUrl: leg.vu,
        photoFinishUrl: leg.pfu,
        last800: leg.l8,
        raceDetailText: leg.rd,
        resultList: leg.br?.map(r => ({
          name: r.n,
          amount: r.a,
          result: r.r,
          description: r.d,
          noWinner: r.nw,
        })),
        horseDetail: leg.h?.map(horse => {
          return {
            key: horse.k,
            isRunning: horse.ir,
            stablemateGroupInfo: horse.sgi,
            comment: horse.c,
            agf: horse.a,
            agfOrderNo: horse.aon,
            secondAgf: horse.sa,
            secondAgfOrderNo: horse.saon,
            accessory: horse.ac,
            horseNo: horse.hn,
            name: horse.n,
            uniform: horse.u,
            probableGain: horse.pg,
            delayStart: horse.ds,
            diffrance: horse.d,
            resultOrderNo: horse.r || 99,
            resultTime: horse.rt,
            tag: horse.t ? {
              isApprentice: horse.t.ia,
              isJockeyChanged: horse.t.ijc,
              weight: horse.t.w,
              weightChanges: horse.t.wd,
              handicap: horse.t.h,
              age: horse.t.a,
              lastRaceRanks: horse.t.lrr,
              boxNo: horse.t.b,
              isPreferredBoxNo: horse.t.ipbn,
              kgs: horse.t.k,
              isProbableGainIncreased: horse.t.ipgi,
              jokeyDetail: nameMaper(horse.t.jd),
            } : null,
          };
        }),
      };
    }),
  };
};

export const findInHippodrome = (hippodromeLocation, allHippodromes) => {
  if (!hippodromeLocation || !allHippodromes) {
    return false;
  }

  const found = allHippodromes.find(h => h.location === hippodromeLocation.toLowerCase());
  if (found) {
    return found;
  }

  return false;
};

export const findInHippodromeByName = (hippName, allHippodromes) => {
  if (!hippName || !allHippodromes) {
    return false;
  }

  const found = allHippodromes.find(h => h.name === hippName);
  if (found) {
    return found;
  }

  return false;
};

export const findInHippodromeByKey = (key, allHippodromes) => {
  if (!key || !allHippodromes) {
    return false;
  }

  const found = allHippodromes.find(h => h.key === key.toUpperCase());
  if (found) {
    return found;
  }

  return false;
};

export const horseMapperForBetslip = horse => {
  if (!horse || !horse.name) {
    return null;
  }

  return ({
    key: horse.key,
    agf: horse.agf,
    uniqId: horse.horseNo + '-' + slugify(horse.name, { lower: true }),
    agfOrderNo: horse.agfOrderNo,
    horseNo: horse.horseNo,
    name: horse.name,
    stablemateGroupInfo: horse.stablemateGroupInfo,
    isRunning: horse.isRunning,
    tag: horse.tag,
    probableGain: horse?.probableGain,
    origin: horse?.origin,
    ownership: horse?.ownership,
    lastThreeRaces: horse?.lastThreeRaces,
    accessory: horse?.accessory,
    propositionInfo: horse?.propositionInfo || null
  });
};

export const isStrictHippdrome = key => {
  const _strictHippodromes = ['ADANA', 'ISTANBUL', 'IZMIR', 'BURSA', 'ANKARA', 'SANLIURFA', 'ELAZIG', 'DIYARBAKIR', 'KOCAELI', 'ANTALYA'];

  return _strictHippodromes.includes(key);
};

export const RUNWAY_TYPES = {
  SAND: 'Kum', // '#7f675b'
  SYNTHETIC: 'Sentetik', // '#b68876'
  TAPETA: 'Tapeta', // '#b68876'
  GRASS: 'Çim' // '#007738'
};

export const horseRacingCouponToBetslipMapper = (_data, bet) => { // kayıtlı kupondan, kupon detaydan veya yorumculardan kupon oynama esnasında, verilen kupon datasını betslip datasına çevirir.
  if (!_data) {
    return null;
  }
  const {
    betTypeId,
    selectableRace,
    raceNumber,
    legSize,
    minSelectedHorseCount,
    betSlipBoxTitle,
    boxTitle,
    betTypeName,
    abbreviatedName
  } = bet;

  const myBet = {
    id: betTypeId,
    description: betTypeName || _data.betTypeName,
    descriptionAbbr: abbreviatedName || _data.abbreviatedName,
    legSize: legSize,
    boxTitle: boxTitle,
    betslipBoxTitle: betSlipBoxTitle,
    isCombinationActive: _data.isCombinationActive,
    minHorseSelectCount: minSelectedHorseCount,
  };

  const isInline = _data.couponLegs.length > 1 && _data.couponLegs.every(leg => leg.raceNo === _data.couponLegs[0].raceNo);

  const legsDataMapper = () => {
    if (isInline) {
      const _leg = _data.couponLegs[0];

      return [{
        legNo: _leg.raceNo,
        startTime: _leg.raceHour,
      }];
    }

    let _arr = _data.couponLegs.filter(e => e.raceNo >= raceNumber).map(e => {
      return {
        legNo: e.raceNo,
        startTime: e.raceHour,
      };
    }
    );

    return _arr.slice(0, myBet.legSize);
  };

  const legsMapper = () => {

    if (isInline) {
      const nulls = new Array(1).fill(null);

      const horses = _data.couponLegs.map(leg => {
        return leg.horses.map(horse => ({
          uniqId: horse.horseNumber + '-' + slugify(horse.horseName, { lower: true }),
          horseNo: horse.horseNumber,
          name: horse.horseName,
          isRunning: !horse.isNotRunning
        }));
      }).slice(0, myBet.legSize);

      return nulls.concat(horses);

    }

    const nulls = new Array(raceNumber).fill(null);

    const horses = _data.couponLegs.filter(leg => leg.raceNo >= raceNumber).map(leg => {
      return leg.horses.map(horse => ({
        uniqId: horse.horseNumber + '-' + slugify(horse.horseName, { lower: true }),
        horseNo: horse.horseNumber,
        name: horse.horseName,
        isRunning: !horse.isNotRunning
      }));
    }).slice(0, myBet.legSize);

    return nulls.concat(horses);
  };

  return {
    isOpen: true,
    selectedInfos: {
      selectedHippodrome: {
        cardId: _data.cardId,
        raceDate: _data.firstRaceStartDate || null,
        name: _data.hippodromeDisplayName,
      },
      selectedBet: myBet,
      legsData: legsDataMapper(),
      selectedRaceNumber: selectableRace
    },
    legs: legsMapper(),
    bultenInfo: {
      hpdm: null,
      bt: null,
      rt: null,
    },
    isBultenChanged: true,
    lastAddedLeg: {},
    isLoading: null,
    error: null,
    verify: {
      data: [],
      isLoading: null,
      error: null,
    },
    footerData: {
      multiplier: 1,
      couponCount: 1,
      allVariation: _data.complete
    },
    play: {
      isLoading: false
    },
    isLoadedFromLS: false
  };

};

export const checkNotRunningHorses = (state, data) => { // verify, play ve saveCoupon da koşmayan at hatası alınırsa, bu fonksion çağırılıp, betslipteki atlar güncellenir.
  const notRunners = data?.extras?.notRunners;
  const isInline = state?.selectedInfos?.selectedBet?.legSize !== state?.selectedInfos?.legsData?.length;
  let newBetslipLegs = state.legs;

  if (notRunners?.length) {
    if (isInline) {
      notRunners.forEach(nrLegs => {
        newBetslipLegs.forEach((leg, index) => {
          let betslipLeg = leg;
          if (betslipLeg) {
            nrLegs.horseNumbers.forEach(nrHorseNo => {
              // eslint-disable-next-line max-nested-callbacks
              if (betslipLeg.find(e => e.horseNo === nrHorseNo)) {
                // eslint-disable-next-line max-nested-callbacks
                betslipLeg.find(e => e.horseNo === nrHorseNo).isRunning = false;
              }
            });

            newBetslipLegs[index] = betslipLeg;
          }
        });
      });
    } else {
      notRunners.forEach(nrLegs => {
        let betslipLeg = newBetslipLegs[nrLegs.raceNumber];

        if (betslipLeg) {
          nrLegs.horseNumbers.forEach(nrHorseNo => {
            if (betslipLeg.find(e => e.horseNo === nrHorseNo)) {
              betslipLeg.find(e => e.horseNo === nrHorseNo).isRunning = false;
            }
          });

          newBetslipLegs[nrLegs.raceNumber] = betslipLeg;
        }

      });
    }

  }

  return newBetslipLegs;
};

export const renderHorseLastRaces = lastRaceRanks => {
  if (!lastRaceRanks || lastRaceRanks?.length === 0) {
    return '-';
  }

  if (lastRaceRanks.includes('C') || lastRaceRanks.includes('K') || lastRaceRanks.includes('T') || lastRaceRanks.includes('S')) { // yurtiçi lastRaceRanks (K1K5C1C1C3-K1K2)
    return lastRaceRanks?.match(/-|.{2}/g)?.map((race, index) => {
      const isGrass = race[0] === 'C';
      const isTapeta = race[0] === 'T';
      const isSand = race[0] === 'K';
      const isSynthetic = race[0] === 'S';
      const isEmpty = race[0] === '-';

      const _class = classnames({
        'newsletter-cells__item--last-ranks--grass': isGrass,
        'newsletter-cells__item--last-ranks--tapeta': isTapeta,
        'newsletter-cells__item--last-ranks--sand': isSand,
        'newsletter-cells__item--last-ranks--synthetic': isSynthetic,
        'newsletter-cells__item--last-ranks--empty': isEmpty
      });

      return <div className={ _class } key={ race + index }>{ isEmpty ? race[0] : race[1] }</div>;
    });
  } else { // yurtdışı lastRaceRanks (151513-12)
    return lastRaceRanks?.match(/.{1}/g)?.map((race, index) => {
      const isEmpty = race[0] === '-';

      const _class = classnames({
        'newsletter-cells__item--last-ranks--black': true,
        'newsletter-cells__item--last-ranks--empty': isEmpty
      });

      return <div className={ _class } key={ race + index }>{ race[0] }</div>;
    });
  }
};
